
import AxiosClient from "../../../services/axios.services";

class EstadosServices {
  getEstados = params =>
    AxiosClient.get("/api/app/seleccion_contratacion_estado/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getEstado = id =>
    AxiosClient.get(`/api/app/seleccion_contratacion_estado/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveEstado = data =>
    AxiosClient.post("/api/app/seleccion_contratacion_estado/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editestado = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_estado/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteEstado = id =>
    AxiosClient.delete(`/api/app/seleccion_contratacion_estado/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EstadosServices();